import React, { useState } from "react";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import Typography from "../../components/Typography";
import FilterTag from "../../components/FilterTag/FilterTag";

import { ReactComponent as IconArrowDown } from "../../build/images/icons/arrow-down.svg";
import { ReactComponent as IconArrowDownV2 } from "../../build/images/icons/arrow-down-v2.svg";

import "./select-tag.css";
import InputSearch from "../InputSearch/InputSearch";

export default function SelectTag({
  valueTag,
  priority = false,
  channel = false,
  options = [
    {
      id: 1,
      label: "Option1",
    },
    {
      id: 2,
      label: "Option2",
    },
    {
      id: 3,
      label: "Option3",
    },
  ],
  onSelect,
  onKeyDown,
  placeholder,
  multiple = true,
  isCallCenter = false,
  isCloseOnSelect = true,
}) {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const priorityOptions = [
    {
      id: 3,
      label: "Baixa",
    },
    {
      id: 2,
      label: "Média",
    },
    {
      id: 1,
      label: "Alta",
    },
    {
      id: 4,
      label: "Crítica",
    },
  ];

  const [open, setOpen] = useState(false);
  const [inputSearch, setInputSearch] = useState("");

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleValuePriority = (value) => {
    switch (value) {
      case "Baixa":
        return 3;

      case "Média":
        return 2;

      case "Alta":
        return 1;

      case "Crítica":
        return 4;

      default:
        break;
    }
  };

  const listFilter = (item) => {
    if (inputSearch) {
      if (item.label.toLowerCase().includes(inputSearch.toLowerCase())) {
        return item;
      } else {
        return;
      }
    } else {
      return item;
    }
  };

  const renderItems = () => {
    return (
      <>
        {options.filter(listFilter).map((option) => (
          <>
            <div
              key={option.label}
              value={option.label}
              onClick={() => {
                onSelect(option);
                if (isCloseOnSelect) {
                  handleOpen();
                }
              }}
              className={`menu-item ${
                valueTag && valueTag.find((vlue) => vlue.id === option.id)
                  ? "active"
                  : ""
              }`}
            >
              <Typography.H5 weight={"500"} color="gray-400">
                {option.label}
              </Typography.H5>
            </div>
          </>
        ))}
      </>
    );
  };

  return (
    <div>
      <FormControl
        sx={
          isCallCenter
            ? {
                width: "100%",
                height: 40,
                "& .MuiBox-root": {
                  display: "flex",
                  alignItems: "center",
                  height: "40px",
                  paddingLeft: "10px",
                },
                "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input":
                  {
                    padding: "0px",
                  },
              }
            : { width: "100%", minHeight: 40 }
        }
      >
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          open={open}
          onClose={handleOpen}
          multiple={multiple}
          className={`select-tag-ingweb ${
            isCallCenter ? "select-tag-ingweb--cal-center" : ""
          }`}
          displayEmpty
          value={valueTag}
          input={<OutlinedInput id="select-multiple-chip" />}
          onKeyDown={onKeyDown}
          renderValue={(selected) => {
            return (
              <Box
                onClick={() => handleOpen()}
                sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
              >
                <ul className="multiple-chip-list">
                  {selected.length === 0 ? (
                    <Typography.H5 weight={400} color="gray-125">
                      {placeholder ? placeholder : "Selecione"}
                    </Typography.H5>
                  ) : (
                    selected.map((value) => {
                      const priorityValue = priority
                        ? handleValuePriority(value.label)
                        : "";

                      return (
                        <li key={value.id}>
                          {/* {value.label || value.name} */}
                          {!multiple ? (
                            <span>{value.label || value.name}</span>
                          ) : (
                            <FilterTag
                              label={value.label || value.name}
                              onClose={(e) => {
                                onSelect(value);
                                e.stopPropagation();
                              }}
                            />
                          )}
                        </li>
                      );
                    })
                  )}
                </ul>
              </Box>
            );
          }}
          IconComponent={isCallCenter ? IconArrowDownV2 : IconArrowDown}
          MenuProps={MenuProps}
        >
          <InputSearch
            search={inputSearch}
            setSearch={setInputSearch}
            // handleClick={(e) => handleSearch(searchData)}
            onSearch={(e) => setInputSearch(inputSearch)}
            onKeyDown={true}
          />
          {renderItems()}
        </Select>
      </FormControl>
    </div>
  );
}
